import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../helpers/state.helper';

const initialState = {
  user: null,
};

const reducer = handleActions(
  {
    [types.SET_USER]: mergeIn(action => action.payload),
    [types.CLEAR_USER]: mergeIn(() => initialState),
  },
  initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/user/reducers.js